const journeyCancelTypes = [
  'static', // Generique cancel page (per Business Unit)
  'url' // Redirect to a specific URL
];

const localCancelTypes = [
  'static', // Generique cancel page (per Business Unit)
  'url', // Redirect to a specific URL
  'step' // Redirect to a specific step (cancel.html)
];

/**
 * Generate config with the notion of override provided by the localConfig
 */
const getCancelConfig = (journeyConfig = {}, localConfig = {}) => {
  let config = {};

  /**
   * Get main configuration
   */
  if (typeof journeyConfig.cancel === 'object' && journeyConfig.cancel !== null && journeyCancelTypes.includes(journeyConfig.cancel.type)) {
    config = removeNullFromObject(journeyConfig.cancel);
  }

  /**
   * Override configuration with the local one
   */
  if (typeof localConfig.cancel === 'object' && localConfig.cancel !== null && localCancelTypes.includes(localConfig.cancel.type)) {
    config = Object.assign(config, removeNullFromObject(localConfig.cancel));
  }

  return config;
};

/**
 * Remove all keys with a value equal to null
 * @param  {Object} object Any object
 * @return {Object}        Cleaned object
 */
const removeNullFromObject = object => {
  /**
   * Clone
   */
  object = Object.assign({}, object);

  /**
   * Cleaning
   */
  Object.keys(object).forEach(key => {
    if (object[key] === null) {
      delete object[key];
    }
  });

  return object;
};

const service = {
  getCancelConfig
};

export default service;



// WEBPACK FOOTER //
// ./src/app/services/cancel.js